/* eslint-disable camelcase */

import { createSyncPages } from '@lib/axios/syncPages'
import { useMutation, useQueryClient } from 'react-query'
import useSuccess from '@hooks/useSuccess'
import useCloseDialog from '@hooks/useCloseDialog'

const useCreateAdmin = () => {
  const showSuccess = useSuccess('Sukses', 'Sukses Menambah Setup Store Dashboard Page')
  const closeDialog = useCloseDialog()
  const queryClient = useQueryClient()

  const mutation = useMutation(
    (mdata) => createSyncPages(
      mdata.name,
      mdata.parent_id,
      mdata.order,
      mdata.path,
      mdata.icon
    ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('saas-sync-pages')
      },
    }
  )

  return (data) => mutation.mutate(data, {
    onError: () => closeDialog(),
    onSuccess: () => {
      showSuccess()
    },
  })
}

export default useCreateAdmin
